module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "boolean-expression-wrapper",
    class: {
      isRule: _vm.isRule, editMode: _vm.editMode, negated: _vm.isNegated
    }
  }, [(!_vm.isEmpty && _vm.expression.negate) ? _c('span', {
    staticClass: "not-token"
  }, [_vm._v("NOT")]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty && _vm.expression.negate || !_vm.isRule) ? _c('span', {
    staticClass: "parent-token"
  }, [_vm._v("(")]) : _vm._e(), _vm._v(" "), (_vm.isEmpty) ? [(!_vm.editMode) ? _c('span', [_c('i', [_vm._v("empty")])]) : _c('button', {
    staticClass: "edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])] : (_vm.isRule) ? [_c('span', {
    staticClass: "field-label"
  }, [_vm._v(_vm._s(_vm.expression.field_label))]), _vm._v(" "), _c('span', {
    staticClass: "operator-label"
  }, [_vm._v(_vm._s(_vm.expression.operator_label))]), _vm._v(" "), (_vm.expression.rendered_values) ? _c('span', {
    staticClass: "rendered-label"
  }, [_vm._v(_vm._s(_vm.expression.rendered_values))]) : _vm._e()] : [_vm._l((_vm.operands), function(nestedExpression, ix) {
    return [_c('boolean-expression', {
      attrs: {
        "expression": nestedExpression,
        "editMode": _vm.editMode
      },
      on: {
        "editExpression": _vm.editNestedExpression,
        "addExpression": _vm.addNestedExpression
      }
    }), _vm._v(" "), (ix < _vm.expressionLength - 1) ? _c('span', {
      staticClass: "boolean-connector"
    }, [(_vm.isAnd) ? _c('span', [_vm._v("AND")]) : (_vm.isOr) ? _c('span', [_vm._v("OR")]) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), (_vm.editMode) ? [(_vm.expressionLength) ? _c('span', {
    staticClass: "boolean-connector"
  }, [(_vm.isAnd) ? _c('span', [_vm._v("AND")]) : (_vm.isOr) ? _c('span', [_vm._v("OR")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "edit-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])] : _vm._e()], _vm._v(" "), (!_vm.isEmpty && _vm.expression.negate || !_vm.isRule) ? _c('span', {
    staticClass: "parent-token"
  }, [_vm._v(")")]) : _vm._e(), _vm._v(" "), (!_vm.isEmpty && _vm.editMode) ? _c('button', {
    staticClass: "edit-btn edit-btn-rule",
    on: {
      "click": _vm.edit
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f40f2f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/BooleanExpression.vue
// module id = 650
// module chunks = 0